export function strDateFormat(date) {
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  return `${day < 10 ? "0" + day : day}/${
    month < 10 ? "0" + month : month
  }/${year}`;
}

export function strDateFormatWithTime(date) {
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let hours = date.getHours();
  let minutes = date.getMinutes();

  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  return `${day}/${month}/${year} - ${hours}:${minutes}`;
}

export function mapPickingStatus(status) {
  switch (status) {
    case "pending":
      return "Pendiente";
    case "ready_to_print":
      return "Listo para imprimir";
    case "send_to_client":
      return "Enviado a la cola de impresión";
    case "printed":
      return "Impreso";
    case "failed":
      return "Fallido";
    default:
      return "Pendiente";
  }
}

export function mapStatus(status) {
  switch (status) {
    case "pending":
      return "Pendiente";
    case "created_on_courier":
      return "Creado en courier";
    case "fulfilled":
      return "Preparado";
    case "ready_for_pickup":
      return "Listo para retiro";
    case "withdrawn":
      return "Retirado";
    case "in_transit":
      return "En tránsito";
    case "in_cd":
      return "En CD";
    case "dropped_at_hub":
      return "Dejado en Hub";
    case "on_the_way":
      return "En camino";
    case "delivered":
      return "Entregado";
    case "failed":
      return "Fallido";
    case "returning":
      return "En devolución";
    case "returned":
      return "Devuelto";
    case "damaged":
      return "Siniestrado";
    case "compensated":
      return "Indemnizado";
    case "cancelled":
      return "Cancelado";
    case "assigned":
      return "Asignado";
    case "waiting_for_assignment":
      return "Por asignar";
    case "packed":
      return "Pedido armado";
    default:
      break;
  }
}

export function mapStatusDashboard(status) {
  switch (status) {
    case "pending":
      return "Pendiente";
    case "created_on_courier":
      return "Creado";
    case "fulfilled":
      return "Preparado";
    case "ready_for_pickup":
      return "Para retiro";
    case "withdrawn":
      return "Retirado";
    case "in_transit":
      return "Transitando";
    case "in_cd":
      return "En CD";
    case "dropped_at_hub":
      return "En Hub";
    case "on_the_way":
      return "En camino";
    case "delivered":
      return "Entregado";
    case "failed":
      return "Fallido";
    case "returning":
      return "Retornando";
    case "returned":
      return "Devuelto";
    case "damaged":
      return "Siniestrado";
    case "compensated":
      return "Indemnizado";
    case "cancelled":
      return "Cancelado";
    case "assigned":
      return "Asignado";
    case "waiting_for_assignment":
      return "Por asignar";
    case "packed":
      return "Pedido armado";
    default:
      break;
  }
}

export const mapSubtatus = (substatus) => {
  switch (substatus) {
    case "not_specified":
      return "";
    case "partial":
      return "Parcial";
    case "complete":
      return "Completo";
    case "rejected":
      return "Rechazado";
    case "incomplete_address":
      return "Dirección Incompleta";
    case "absent_client":
      return "Cliente ausente";
    case "nonexisting_address":
      return "Dirección no existe";
    case "out_of_range":
      return "Sin cobertura";
    case "bad_data":
      return "Datos erróneos";
    case "out_of_schedule":
      return "Fuera de horario";
    case "not_delivered":
      return "No entregado";
    case "spoiled_package":
      return "Embalaje dañado";
    case "missing_package":
      return "Extraviado";
    case "spoiled_content":
      return "Contenido dañado";
    case "internal_reader":
      return "Gestión interna";
    case "external_reader":
      return "Gestión externa";
    default:
      break;
  }
};

export function mapStatusWithdrawal(status) {
  switch (status) {
    case "created":
      return "Creado";
    case "pending":
      return "Retiro pendiente";
    case "withdrawn":
      return "Retirado";
    default:
      return "Estado desconocido";
  }
}

export function dateToDatabase(dateObject) {
  if (!dateObject) return null;
  return dateObject.toISOString().split("T")[0];
}

export function dateToLocalDatabase(dateObject) {
  if (!dateObject) return null;

  const year = dateObject.getFullYear();
  const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  const day = String(dateObject.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function deliverySystemTranslate(deliverySystem) {
  switch (deliverySystem) {
    case "delivery":
      return "Delivery";
    case "pickup":
      return "Pickup";
    case "meli":
      return "Envío Meli";
    case "meli_flex":
      return "Envío Meli Flex";
    case "region":
      return "Envío Región";
    case "not_selected":
      return "No seleccionado";
    case "rm_same_day":
      return "Envío RM Same day";
    case "rm_next_day":
      return "Envío RM Next day";
    case "click_collect":
      return "Click & Collect";
    case "express":
      return "Envío Express";
    case "same_day":
      return "Envío Same Day";
    case "regional":
      return "Envío Regional";
    case "rm_rural":
      return "Envío RM Rural";
    case "pod":
      return "Envío a Punto de Despacho";
    default:
      return "Desconocido";
  }
}

export function filterStatusByOrderType(order) {
  let allowedStatus = [];
  let statusMapping = {};
  let allowedSubStatus = [];
  let subStatusMapping = {};

  if (order.type === "click_collect" || order.type === "pay_collect") {
    allowedStatus = ["in_preparation", "pending_assignment", "completed"];
    statusMapping = {
      in_preparation: "En preparación",
      pending_assignment: "Listo para retirar",
      completed: "Entregado",
    };
  } else if (
    order.type === "delivery" ||
    order.type === "delivery_fulfillment" ||
    order.type === "pick_up" ||
    order.type === "pick_up_fulfillment" ||
    order.type === "rm_same_day"
  ) {
    allowedStatus = [
      "pending",
      "created_on_courier",
      "fulfilled",
      "ready_for_pickup",
      "withdrawn",
      "in_transit",
      "in_cd",
      "dropped_at_hub",
      "on_the_way",
      "delivered",
      "failed",
      "returning",
      "returned",
      "damaged",
      "compensated",
      "cancelled",
      "in_preparation",
      "pending_assignment",
      "pick_up_ready",
      "assigned",
      "waiting_for_assignment",
      "packed"
      
    ];
    allowedSubStatus = [
      "not_specified",
      "partial",
      "complete",
      "rejected",
      "incomplete_address",
      "absent_client",
      "nonexisting_address",
      "out_of_range",
      "bad_data",
      "product_not_match",
      "rescheduled",
      "route_pending",
      "out_of_schedule",
      "not_delivered",
      "spoiled_package",
      "missing_package",
      "spoiled_content",
      "external_reader",
      "internal_reader",
    ];
    statusMapping = {
      pending: "Pendiente",
      created_on_courier: "Creado en courier",
      fulfilled: "Preparado",
      ready_for_pickup: "Listo para retiro",
      withdrawn: "Retirado",
      in_transit: "En tránsito",
      in_cd: "En CD",
      dropped_at_hub: "Dejado en hub",
      on_the_way: "En camino",
      delivered: "Entregado",
      failed: "Fallido",
      returning: "En devolución",
      returned: "Devuelto",
      damaged: "Siniestrado",
      compensated: "Indemnizado",
      cancelled: "Cancelado",
      in_preparation: "En preparación",
      pending_assignment: "Preparado para envío",
      pick_up_ready: "Listo para retirar",
      assigned: "Asignado",
      waiting_for_assignment: "Por asignar",
      packed: "Pedido armado",
    };
    subStatusMapping = {
      not_specified: "",
      partial: "Parcial",
      complete: "Completo",
      rejected: "Rechazado",
      incomplete_address: "Dirección Incompleta",
      absent_client: "Cliente ausente",
      nonexisting_address: "Dirección no existe",
      out_of_range: "Sin cobertura",
      bad_data: "Datos erróneos",
      product_not_match: "Producto no corresponde",
      rescheduled: "Reprogramado",
      route_pending: "Pendiente de ruta",
      out_of_schedule: "Fuera de horario",
      not_delivered: "No entregado",
      spoiled_package: "Embalaje dañado",
      missing_package: "Extraviado",
      spoiled_content: "Contenido dañado",
      internal_reader: "Gestión interna",
      external_reader: "Gestión externa",
    };
  }
  // normalize POD which comes with alt media urls (Circuit...tms1,tms2...)
  const normalizeImageUrl = (url) => {
    if (url.includes("firebasestorage.googleapis.com") && !url.includes("alt=media")) {
      return url + (url.includes("?") ? "&" : "?") + "alt=media";
    }
    return url;
  };

  const filteredAndMappedStatus = order.combined_status_history
    .filter((status) => allowedStatus.includes(status.status))
    .filter((status) => allowedSubStatus.includes(status.substatus))
    .map((status) => ({
      id: status.id,
      status: status.status,
      friendlyStatus: statusMapping[status.status] || status.status,
      date: status.date,
      details: status.details,
      image_urls: status.image_urls,
      substatus: status.substatus,
      friendlySubStatus: subStatusMapping[status.substatus] || "",
      source: status.source,
      external_source: status.external_source,
    }));

  return filteredAndMappedStatus;
}

export function capitalizeWords(string) {
  return string
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

// return an array object with statuses
export function getDeliveryStatus() {
  return [
    {
      id: 1,
      system_name: "pending",
      user_name: "Pendiente",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#D3D3D3",
    },
    {
      id: 2,
      system_name: "created_on_courier",
      user_name: "Creado en courier",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#D3D3D3",
    },
    {
      id: 3,
      system_name: "ready_for_pickup",
      user_name: "Listo para retiro",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#D3D3D3",
    },
    {
      id: 4,
      system_name: "withdrawn",
      user_name: "Retirado",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
        {
          id: 4,
          system_name: "internal_reader",
          user_name: "Gestión interna",
        },
        {
          id: 5,
          system_name: "external_reader",
          user_name: "Gestión externa",
        },
      ],
      color: "#D3D3D3",
    },
    {
      id: 5,
      system_name: "in_transit",
      user_name: "En tránsito",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#ffdf80",
    },
    {
      id: 6,
      system_name: "in_cd",
      user_name: "En CD",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#ffdf80",
    },
    {
      id: 7,
      system_name: "dropped_at_hub",
      user_name: "Dejado en hub",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#ffdf80",
    },
    {
      id: 8,
      system_name: "on_the_way",
      user_name: "En camino",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#ffdf80",
    },
    {
      id: 9,
      system_name: "delivered",
      user_name: "Entregado",
      substatus: [
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#36D9C0",
    },
    {
      id: 10,
      system_name: "failed",
      user_name: "Fallido",
      substatus: [
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
        {
          id: 4,
          system_name: "rejected",
          user_name: "Rechazado",
        },
        {
          id: 5,
          system_name: "incomplete_address",
          user_name: "Dirección Incompleta",
        },
        {
          id: 6,
          system_name: "absent_client",
          user_name: "Cliente ausente",
        },
        {
          id: 7,
          system_name: "nonexisting_address",
          user_name: "Dirección no existe",
        },
        {
          id: 8,
          system_name: "out_of_range",
          user_name: "Sin cobertura",
        },
        {
          id: 9,
          system_name: "bad_data",
          user_name: "Datos erróneos",
        },
        {
          id: 10,
          system_name: "route_pending",
          user_name: "Pendiente de ruta",
        },
        {
          id: 12,
          system_name: "product_not_match",
          user_name: "Producto no corresponde",
        },
        {
          id: 12,
          system_name: "rescheduled",
          user_name: "Reprogramado",
        },
        {
          id: 13,
          system_name: "out_of_schedule",
          user_name: "Fuera de horario",
        },
        {
          id: 14,
          system_name: "not_delivered",
          user_name: "No entregado",
        },
      ],
      color: "#ff6666",
    },
    {
      id: 11,
      system_name: "returning",
      user_name: "En devolución",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#6446d2",
    },
    {
      id: 12,
      system_name: "returned",
      user_name: "Devuelto",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#6446d2",
    },
    {
      id: 13,
      system_name: "damaged",
      user_name: "Siniestrado",
      substatus: [
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
        {
          id: 12,
          system_name: "spoiled_package",
          user_name: "Embalaje dañado",
        },
        {
          id: 13,
          system_name: "missing_package",
          user_name: "Extraviado",
        },
        {
          id: 14,
          system_name: "spoiled_content",
          user_name: "Contenido dañado",
        },
      ],
      color: "#B3122D",
    },
    {
      id: 14,
      system_name: "compensated",
      user_name: "Indemnizado",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#33800D",
    },
    {
      id: 15,
      system_name: "cancelled",
      user_name: "Cancelado",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#B3122D",
    },
    {
      id: 16,
      system_name: "assigned",
      user_name: "Asignado",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#D3D3D3",
    },
     {
      id: 17,
      system_name: "fulfilled",
      user_name: "Preparado",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
        {
          id: 2,
          system_name: "partial",
          user_name: "Parcial",
        },
        {
          id: 3,
          system_name: "complete",
          user_name: "Completado",
        },
      ],
      color: "#D3D3D3",
    },
      {
      id: 18,
      system_name: "waiting_for_assignment",
      user_name: "Por asignar",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
      ],
      color: "#D3D3D3",
    },
    {
      id: 19,
      system_name: "packed",
      user_name: "Pedido armado",
      substatus: [
        {
          id: 1,
          system_name: "not_specified",
          user_name: "No aplica",
        },
      ],
      color: "#D3D3D3",
    },
  ];
}

// return an array with default webhooks attr
export function getDefaultWebhookAttrs() {
  return [
    "{{order_id}}",
    "{{reference_id}}",
    "{{status}}",
    "{{substatus}}",
    "{{status_timestamps}}",
    "{{comments}}",
    "{{recipient_name}}",
    "{{recipient_phone}}",
    "{{recipient_email}}",
    "{{address}}",
    "{{street_number}}",
    "{{commune}}",
    "{{region}}",
    "{{url_images}}",
    "{{current_date}}",,
    "{{order_notes}}"
  ];
}

export function getAltanetTemplate() {
  return {
    Empresa: "{{seller_social_reason}}",
    Bodega: "SANTA_ELENA",
    Usuario: "NinjaHub",
    Entidad: {
      Empresa: "{{seller_social_reason}}",
      Entidad: "Qslogisticsprueba01",
      Nombre: "{{recipient_name}}",
      Tipo_relacion_comercial: "CL",
      Rut: 0,
      Dv: "",
      Giro: "",
      Direccion: "{{address}} {{street_number}}",
      Comuna: "{{commune}}",
      Telefono: "{{recipient_phone}}",
      Estado: "AC",
      Email: "{{recipient_email}}",
    },
    Movimiento_solicitado: {
      Empresa: "{{seller_social_reason}}",
      Bodega: "SANTA_ELENA",
      Documento_solicitado: "OD",
      Tipo_movimiento: "DEC",
      Fecha_movimiento: "{{current_date}}",
      Fecha_programada: "{{scheduled_date}}",
      Responsable: "aduran",
      Entidad: "Qslogisticsprueba01",
      Documento_respaldo: "PR",
      Numero_documento_respaldo: "{{reference_id}}",
      IDENTIFICADOR_ERP: "{{order_id}}",
      Notas: "Sitio 27",
      Estado: "AU",
    }
  };
}

export function safeParseJSON(data) {
  if (!data) return {};
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error("Error parseando JSON del backend:", error);
      return {};
    }
  }
  return data;
}

export const buildJsonObject = (nodes) => {
  const obj = {};

  nodes.forEach((node) => {
    if (!node.key) return;

    if (node.type === "object") {
      obj[node.key] = buildJsonObject(node.children || []);
    } else if (node.type === "array") {
      obj[node.key] = (node.children || []).map((child) => {
        if (child.type === "object") {
          return buildJsonObject(child.children || []);
        }
        return child.value;
      });
    } else if (node.type === "number") {
      obj[node.key] = Number(node.value);
    } else if (node.type === "boolean") {
      obj[node.key] = node.value === "true" || node.value === true;
    } else {
      obj[node.key] = node.value;
    }
  });

  return obj;
};

export const jsonToNodes = (json) => {
  return Object.entries(json).map(([key, value]) => {
    if (Array.isArray(value)) {
      return {
        id: Date.now().toString() + Math.random(),
        key: key,
        type: "array",
        value: "",
        children: value.map((item, index) => ({
          id: Date.now().toString() + Math.random(),
          key: `Item ${index + 1}`,
          type: typeof item === "object" && item !== null ? "object" : "string",
          value: typeof item !== "object" ? item : "",
          children:
            typeof item === "object" && item !== null ? jsonToNodes(item) : [],
        })),
      };
    } else if (typeof value === "object" && value !== null) {
      return {
        id: Date.now().toString() + Math.random(),
        key: key,
        type: "object",
        value: "",
        children: jsonToNodes(value),
      };
    } else {
      return {
        id: Date.now().toString() + Math.random(),
        key: key,
        type: typeof value,
        value: value,
        children: [],
      };
    }
  });
};



export function checkDownloadStatus(status) {
  let message = "";
  switch (status) {
    case "started":
      message = "🏁 Descarga iniciada";
      break;
    case "processing":
      message = "⬇️ Descarga en proceso";
      break;
    case "completed":
      message = "✅ Descarga completa";
      break;
    case "failed":
      message = "❌ Descarga fallida";
      break;
    default:
      break;
  }
  return message;
}

export function checkDownloadStatusNew(status, url) {
  switch (status) {
    case "started":
      return "🏁 Descarga iniciada";
    case "processing":
      return "⬇️ Descarga en proceso";
    case "completed":
      if (url) {
        return (
          <span>
            ✅ Reporte listo —{" "}
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              style={{ color: "inherit", textDecoration: "underline", outline: "none" }}
            >
              Descargar archivo
            </a>
          </span>
        );
      }
      return "✅ Descarga completa";
    case "failed":
      return "❌ Descarga fallida";
    default:
      return "";
  }
}

export function isToday(someDate) {
  const today = new Date();
  return (
    someDate.getDate() === today.getDate() &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  );
}

export function formatDate(date) {
  const options = {
    day: "2-digit",
    month: "long",
  };
  return new Intl.DateTimeFormat("es-CL", options).format(date);
}

export function convertFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function generateRandomToken(length) {
  const chars = `qwertyuiopasdfghjkl;nmzxcvb,./'-0987654321`;
  let result = "";
  const charsLength = chars.length;
  for (let i = 0; i < charsLength; i++) {
    result += chars.charAt(Math.floor(Math.random() * charsLength));
  }
  return result;
}

export const getStatusColor = (current) => {
  const currentStatus = getDeliveryStatus().find(
    (status) => current === status.system_name,
  );
  return currentStatus.color;
};
